import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";
import { MRT_PaginationState } from "mantine-react-table";

export interface BalancesListingResponse {
  data: BalancesListing[];
  totalRowCount: number;
  totalPages: number;
}

export interface BalancesListing {
  amount: number;
  currency: string;
  currencyName: string;
}

interface GetBalancesListingRequest {
  token: string;
  externalAccount: string;
  pagination: MRT_PaginationState;
}

const getBalancesListing = async ({
  token,
  externalAccount,
  pagination,
}: GetBalancesListingRequest): Promise<BalancesListingResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/getBalancesListing`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          // Add 1 to pageIndex to convert from 0-based to 1-based index
          externalAccount,
          page: `${pagination.pageIndex + 1}`,
          pageSize: `${pagination.pageSize}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getBalancesListing;
